import type { CityConfig } from "../city-template/types";

export const lawtonConfig: CityConfig = {
  city: "Lawton",
  state: "Oklahoma",
  stateAbbr: "OK",
  slug: "lawton",
  route: "/cities/lawton",
  title: "Emergency Passport Lawton, OK | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Lawton, OK — as fast as 24 hours. Serving Fort Sill military families and Southwest Oklahoma. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Lawton, OK",
  heroSubtitle: "Fort Sill deployment orders with 72 hours notice? Wichita Mountains weekend trip to Mexico need fast documents? Last-minute PCS to Germany and your passport expired? We help Lawton military families and Southwest Oklahoma residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Lawton%20Oklahoma%20with%20Wichita%20Mountains%20Wildlife%20Refuge%20in%20background%20golden%20prairie%20grasslands%20bison%20herd%20roaming%20Mount%20Scott%20peak%20Fort%20Sill%20army%20base%20historic%20downtown%20Medicine%20Park%20cobblestone%20resort%20town%20warm%20sunset%20light%20professional%20landscape%20photography&width=1800&height=700&seq=lawton-ok-hero-2026&orientation=landscape",
  heroImageAlt: "Lawton Oklahoma with Wichita Mountains and golden prairie at sunset",
  geoPosition: "34.6036;-98.3959",
  geoPlacename: "Lawton, Oklahoma",
  regionalAgency: {
    name: "Dallas Passport Agency",
    address: "1100 Commerce Street, Suite 900, Dallas, TX 75242",
    distance: "Located in downtown Dallas — approximately 190 miles south of Lawton via I-44/I-35",
  },
  nearbyCitiesZips: [
    { name: "Lawton", zips: "73501, 73505, 73507" },
    { name: "Fort Sill", zips: "73503" },
    { name: "Duncan", zips: "73533, 73534" },
    { name: "Altus", zips: "73521, 73522" },
    { name: "Cache", zips: "73527" },
    { name: "Elgin", zips: "73538" },
    { name: "Marlow", zips: "73055" },
    { name: "Chickasha", zips: "73018, 73023" },
    { name: "Wichita Falls, TX", zips: "76301, 76302" },
    { name: "Anadarko", zips: "73005" },
    { name: "Frederick", zips: "73542" },
    { name: "Walters", zips: "73572" },
    { name: "Geronimo", zips: "73543" },
    { name: "Apache", zips: "73006" },
    { name: "Comanche", zips: "73529" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Fort Sill and Southwest Oklahoma departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Fort Sill & Wichita Mountains", desc: "Serving Lawton, Fort Sill, Duncan, Altus, and Southwest Oklahoma" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Oklahoma City, OK", route: "/cities/oklahoma-city" },
    { name: "Fast passport renewal in Tulsa, OK", route: "/cities/tulsa" },
    { name: "Emergency passport help in Norman, OK", route: "/cities/norman" },
    { name: "Urgent passport services in Edmond, OK", route: "/cities/edmond" },
    { name: "Same-day passport help in Dallas, TX", route: "/cities/dallas" },
    { name: "Passport courier services in Wichita Falls area", route: "/cities/wichita-falls" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Lawton remotely via secure courier. We do not have a walk-in office in Lawton — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Comanche County and Southwest Oklahoma.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of Comanche County and the Southwest Oklahoma region including Cotton, Stephens, and Jackson counties",
  serviceAreaIntro: "From the historic Medicine Park cobblestone village and the buffalo-dotted prairies of the Wichita Mountains Wildlife Refuge to the gates of Fort Sill Army Base and the tree-lined streets of downtown Lawton, from the oil-rich communities of Duncan and Marlow to the agricultural towns of Cache and Elgin, from the Quartz Mountain area of Altus to the heritage-rich streets of Chickasha and Anadarko — Fast Passport Center serves the entire Southwest Oklahoma region. We regularly help military families, outdoor enthusiasts, and local travelers get their passports fast without the 190-mile drive to Dallas.",
  nearbyCitiesIntro: "We serve all Lawton neighborhoods and the surrounding Southwest Oklahoma area including Fort Sill, Duncan, Altus, Cache, Elgin, Marlow, Chickasha, and Wichita Falls. If you are anywhere in Comanche County, Stephens County, or Cotton County, we have you covered.",
  howItWorksIntro: "Most Lawton travelers complete everything online and ship documents overnight. No need to drive to Dallas or wait in line at the regional agency.",
  mistakesIntro: "Lawton travelers often face a 3-hour drive to the nearest regional passport agency in Dallas. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Lawton military families and Southwest Oklahoma travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Lawton? Here are the most common ones we hear from Fort Sill and Southwest Oklahoma travelers.",
  statePageRoute: "/states/oklahoma",
  statePageName: "Oklahoma",
  dmvWebsite: "https://oklahoma.gov/dps.html",
  dmvLabel: "Oklahoma DPS — Driver License Services",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–3",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Lawton travelers with immediate departure needs — as fast as 24 hours for urgent international flights or deployment.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Lawton travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens in Lawton with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance for Lawton and Fort Sill residents with step-by-step guidance." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Sgt. Marcus T.",
      location: "Fort Sill, OK",
      rating: 5,
      text: "Got PCS orders to Germany with 10 days notice. Fast Passport Center had my family's passports in 36 hours. The dedicated agent knew exactly what military families need. Saved our move.",
      service: "Emergency Passport",
    },
    {
      name: "Diana R.",
      location: "Lawton, OK",
      rating: 5,
      text: "Our anniversary trip to Cancun was in 4 days when I realized my passport expired. Fast Passport Center got it renewed in 28 hours. From Wichita Mountains to the beach in under a week!",
      service: "Passport Renewal",
    },
    {
      name: "James H.",
      location: "Duncan, OK",
      rating: 5,
      text: "Business trip to London came up last minute. Fast Passport Center got my passport in 2 days. Never even had to leave Duncan. Incredible service for Southwest Oklahoma.",
      service: "Emergency Passport",
    },
  ],
  facilities: [
    {
      id: "lawton-ok-1",
      name: "Lawton Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "501 SW 5th St",
      city: "Lawton",
      state: "OK",
      zip: "73501",
      phone: "(580) 355-8111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Lawton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Lawton facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "lawton-ok-2",
      name: "Comanche County Court Clerk",
      type: "County Court Clerk Passport Acceptance",
      address: "315 SW 5th St, Room 304",
      city: "Lawton",
      state: "OK",
      zip: "73501",
      phone: "(580) 355-4017",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown Lawton Courthouse",
      website: "https://www.comanchecounty.us",
      websiteLabel: "Comanche County Court Clerk",
      notes: "Accepts passport applications. Good alternative to post office. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "lawton-ok-3",
      name: "Duncan Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1007 W Main St",
      city: "Duncan",
      state: "OK",
      zip: "73533",
      phone: "(580) 255-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "30 miles east of Lawton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Stephens County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "lawton-ok-4",
      name: "Altus Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "217 N Hudson St",
      city: "Altus",
      state: "OK",
      zip: "73521",
      phone: "(580) 482-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "55 miles west of Lawton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Altus AFB and Jackson County area.",
      icon: "ri-mail-line",
    },
    {
      id: "lawton-ok-5",
      name: "Chickasha Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2001 W Iowa Ave",
      city: "Chickasha",
      state: "OK",
      zip: "73018",
      phone: "(405) 224-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "45 miles northeast of Lawton",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Grady County. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 3 hour drive to Dallas", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Lawton photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Comanche County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Lawton applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Dallas regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many military families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Lawton travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Lawton." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Lawton address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Lawton before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Lawton for travelers with urgent international flights or military deployment. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 3-hour drive to Dallas." },
    { q: "How fast can I renew my passport in Lawton?", a: "Fast Passport Center offers fast passport renewal in Lawton in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Lawton?", a: "The nearest regional passport agency to Lawton is the Dallas Passport Agency, approximately 190 miles south via I-44/I-35. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Lawton without any in-person agency visit required." },
    { q: "Does Fort Sill have passport services for military families?", a: "Fort Sill military families can use Fast Passport Center's expedited courier service for all passport needs, including deployment-related passport processing. We understand military timelines and PCS requirements. Our 24–48 hour emergency service is ideal for short-notice orders." },
    { q: "Do you serve the entire Southwest Oklahoma region?", a: "Absolutely. Fast Passport Center serves the entire Southwest Oklahoma region including Lawton, Fort Sill, Duncan, Altus, Cache, Elgin, Marlow, Chickasha, and surrounding areas. Our courier service works seamlessly from any address in Comanche County, Stephens County, or Cotton County." },
    { q: "Can I expedite a child passport in Lawton?", a: "Yes. Fast Passport Center expedites child passports in Lawton for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Southwest Oklahoma families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Lawton with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Dallas Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Lawton", address: "1002 NW Sheridan Rd, Lawton, OK 73505", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Lawton", address: "2002 NW Cache Rd, Lawton, OK 73507", hours: "Mon–Sun: 7AM–11PM" },
    { name: "Walgreens — Duncan", address: "1101 N 5th St, Duncan, OK 73533", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walmart Supercenter — Duncan", address: "3393 N Main St, Duncan, OK 73533", hours: "Mon–Sun: 6AM–11PM" },
  ],
  dmvLocations: [
    {
      name: "Oklahoma DPS — Lawton",
      address: "1801 NW 52nd St, Lawton, OK 73505",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Oklahoma DPS — Duncan",
      address: "705 W Main St, Duncan, OK 73533",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Stephens County. REAL ID available. Appointment recommended.",
      featured: false,
    },
    {
      name: "Oklahoma DPS — Altus",
      address: "300 W Commerce St, Altus, OK 73521",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Jackson County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "LAW",
      name: "Lawton-Fort Sill Regional Airport",
      distance: "5 miles south of downtown Lawton",
      address: "3401 SW 11th St, Lawton, OK 73501",
      note: "Regional airport with daily flights to Dallas/Fort Worth via American Eagle. About 10 minutes from Fort Sill.",
      flightUrl: "https://www.flylawton.com/",
      flightLabel: "LAW Airport",
      featured: true,
    },
    {
      code: "OKC",
      name: "Will Rogers World Airport",
      distance: "85 miles northeast of Lawton",
      address: "7100 Terminal Dr, Oklahoma City, OK 73159",
      note: "Major Oklahoma airport with direct flights nationwide. About 1 hour 20 minutes from Lawton via I-44.",
      flightUrl: "https://flyokc.com/",
      flightLabel: "OKC Airport",
      featured: false,
    },
    {
      code: "DFW",
      name: "Dallas/Fort Worth International Airport",
      distance: "175 miles south of Lawton",
      address: "2400 Aviation Dr, DFW Airport, TX 75261",
      note: "Major international hub with direct flights worldwide. About 2 hours 45 minutes from Lawton.",
      flightUrl: "https://www.dfwairport.com/",
      flightLabel: "DFW Airport",
      featured: false,
    },
  ],
};